import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MathGamesSharedModule } from '@games/games-shared/math-games-shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import {
  ButtonModule, DefaultImageModule, FitTextModule, FormFieldModule,
} from '@shared/components/games';
import { LogarithmsControllerComponent } from './logarithms-controller/logarithms-controller.component';
import { LogarithmsCorrectAnswerPreviewComponent } from './logarithms-preview/logarithms-answer-preview/logarithms-answer-preview.component';
import { LogarithmsExamplePreviewComponent } from './logarithms-preview/logarithms-example-preview/logarithms-example-preview.component';
import { LogarithmsParametersPreviewComponent } from './logarithms-preview/logarithms-parameters-preview/logarithms-parameters-preview.component';
import { LogarithmsUserAnswerPreviewComponent } from './logarithms-preview/logarithms-user-answer-preview/logarithms-user-answer-preview.component';
import { LogarithmsSettingsComponent } from './logarithms-settings/logarithms-settings.component';
import {CalculatorLayoutComponent} from '@shared/components/games/input-layouts/calculator-layout/calculator-layout.component';

@NgModule({
  declarations: [
    LogarithmsControllerComponent,
    LogarithmsSettingsComponent,
    LogarithmsCorrectAnswerPreviewComponent,
    LogarithmsExamplePreviewComponent,
    LogarithmsParametersPreviewComponent,
    LogarithmsUserAnswerPreviewComponent,
  ],
  exports: [
    LogarithmsControllerComponent,
    LogarithmsSettingsComponent,
    LogarithmsCorrectAnswerPreviewComponent,
    LogarithmsExamplePreviewComponent,
    LogarithmsParametersPreviewComponent,
    LogarithmsUserAnswerPreviewComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ButtonModule,
    FitTextModule,
    NgSelectModule,
    DefaultImageModule,
    FormFieldModule,
    MathGamesSharedModule,
    CalculatorLayoutComponent,
  ],
})
export class LogarithmsModule {}
